import { useState } from 'react';
import { ReactComponent as LoadingSvg } from '../../../assets/svg/loading-half-status.svg';
import { useCountdown } from '../../../hook/useCountdown';

const EmailVerification = ({
  verificationCode,
  sendVerificationCode,
  verificationCodeSent,
  handleInputVerificationCode,
  sendCodeLoading,
}) => {
  const [countdownStart, setCountdownStart] = useState(false);
  const [countDown, setCountDown] = useState(180);
  const [minutes, seconds] = useCountdown({
    start: countdownStart,
    stop: () => setCountdownStart(false),
    countDown,
    setCountDown,
  });

  const handleClickSendVerificationCode = () => {
    sendVerificationCode();
    setCountDown(180);
    setCountdownStart(true);
  };

  return (
    <div className='mt-2 space-y-2'>
      <button
        className='rounded-full px-2 py-1 text-sm flex items-center gap-2 bg-white border-2 border-yellow-500 font-bold'
        onClick={handleClickSendVerificationCode}
        disabled={sendCodeLoading}
      >
        <span>
          {verificationCodeSent ? 'resend code' : 'send verification code'}
        </span>
        {sendCodeLoading && (
          <LoadingSvg
            className='animate-spin text-slate-300 inline'
            width={16}
            height={16}
          />
        )}
      </button>
      {verificationCodeSent && (
        <div className='flex items-center justify-between gap-2'>
          <div className='w-full bg-white rounded-full py-2 px-4'>
            <input
              type='text'
              className='w-full border-none '
              placeholder='6-digit verification code'
              value={verificationCode}
              onChange={handleInputVerificationCode}
            />
          </div>
          <div
            className={`text-xs ${
              minutes === '00' && seconds === '00'
                ? 'text-red-600'
                : 'text-green-600'
            }`}
          >
            {minutes === '00' && seconds === '00'
              ? 'code expired'
              : `${minutes}:${seconds}`}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailVerification;
